import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const createAudit = api(
    function createAudit(shortDescription, longDescription, type, referenceId, payload, auditId) {
        return mutate(
            gql`
                mutation CreateAudit(
                    $shortDescription: String!
                    $longDescription: String!
                    $type: String!
                    $referenceId: String!
                    $payload: JSONObject
                    $auditId: String
                ) {
                    createAudit(
                        shortDescription: $shortDescription
                        longDescription: $longDescription
                        type: $type
                        referenceId: $referenceId
                        payload: $payload
                        auditId: $auditId
                    ) {
                        shortDescription
                        longDescription
                        type
                        referenceId
                        payload
                    }
                }
            `,
            { shortDescription, longDescription, type, referenceId, payload, auditId },
            { returns: "createAudit" }
        )
    }
)
